import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom"
import { AddUser } from "./AddUser";


export const EditUser = () =>{
    const location = useLocation();
    const [userId, setUserId] = useState();
    useEffect(()=>{
        let userId = location.pathname.split("/")[2];
        if(userId){
            setUserId(userId)
        }
    },[])

    return <><AddUser userId={userId}/></>
}